import { QuestionModel } from './question.model';

export class IssueRelatedQuestionModel {
  id: number;
  issueId: string;
  isActive: boolean;
  elementType: string;
  type: string;
  elements: Array<QuestionModel> = [];
}
